import { useState, useRef } from 'react';
import { formatTime } from '../utils';

export const useTimer = () => {
    const [elapsedTime, setElapsedTime] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const startTimeRef = useRef<number | null>(null);
    const intervalRef = useRef<number | null>(null);

    const startTimer = () => {
        if (isRunning) return;
        setIsRunning(true);
        startTimeRef.current = Date.now() - elapsedTime;
        intervalRef.current = window.setInterval(() => {
            if (startTimeRef.current) {
                setElapsedTime(Date.now() - startTimeRef.current);
            }
        }, 1000);
    };

    const stopTimer = () => {
        if (!isRunning) return;
        setIsRunning(false);
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };

    const resetTimer = () => {
        stopTimer();
        setElapsedTime(0);
        startTimeRef.current = null;
    };

    return {
        displayTime: formatTime(elapsedTime),
        startTimer,
        stopTimer,
        resetTimer,
        isRunning
    };
};
